<p>Current start date: {{ dateStringFromISO8601(membership.start_date) }}</p>

<div class="form-group">
  <label for="startDate">New start date</label>
  <app-date-picker [id]="'startDate'"
                   [(content)]="startDate"></app-date-picker>
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
